import { defineComponent as _defineComponent } from 'vue'
import { watch } from 'vue'
import { reactive, ref } from 'vue'
import { CandidateDashboardStatsGetters, LocalizationPath } from '@tokyojob/core'
import { CIconFactory, getLocalization, CIcon, IconSize } from '@tokyojob/frontend-components'
import { LocalizationService } from '@tokyojob/frontend-core'
import { getAppStore } from '~/store/app.store'
import { IApp } from '~/types/nuxt'
import { getProvidedApp, getRoute } from '~/base/utils/provided-getter'


export default /*#__PURE__*/_defineComponent({
  __name: 'c-sidebar-candidate-menu.component',
  emits: ['toggleMenu'],
  setup(__props, { emit }) {



function toggleMenu() {
  emit('toggleMenu')
}
const app: IApp = getProvidedApp()
const localization = getLocalization(app)
const appStore = getAppStore()
const stats = appStore.dashboardStats
const hasNewMessages = ref(CandidateDashboardStatsGetters.hasNewMessages(stats))
const newMessages = ref(stats?.newMessages)
const messagesIcon = CIconFactory.Icon({ icon: 'circle', size: IconSize.medium, classes: 'color-green-dark2' })
const applicationsLink = '/application'
const profileLink = '/profile'
const accountLink = '/account'
const resumeLink = '/resume'
const sidebarCandidateTitle = LocalizationService.t<string>(localization, LocalizationPath.sidebarCandidateTitle)
const myJobs = LocalizationService.t<string>(localization, LocalizationPath.myJobs)
const myProfile = LocalizationService.t<string>(localization, LocalizationPath.myProfile)
const myAccount = LocalizationService.t<string>(localization, LocalizationPath.myAccount)
const resume = LocalizationService.t<string>(localization, LocalizationPath.resumeListTitle)
const briefcaseIcon = CIconFactory.Icon({ icon: 'briefcase', size: IconSize.size16 })
const circleUserIcon = CIconFactory.Icon({ icon: 'circle-user', size: IconSize.size16 })
const fileIcon = CIconFactory.Icon({ icon: 'file-lines', size: IconSize.size16 })
const slidersIcon = CIconFactory.Icon({ icon: 'sliders', size: IconSize.size16 })
const cookieRepository = reactive(app.state)
const isLoggedInCandidate = ref(cookieRepository.isLoggedInCandidate)
const route = getRoute()

function exactActiveClass(link: string) {
  return route.value.path === link ? 'nuxt-link-exact-active' : ''
}

const links = [
  { path: profileLink, icon: circleUserIcon, label: myProfile },
  { path: resumeLink, icon: fileIcon, label: resume },
  { path: accountLink, icon: slidersIcon, label: myAccount }
]

watch(
  () => appStore.dashboardStats,
  (newVal) => {
    hasNewMessages.value = CandidateDashboardStatsGetters.hasNewMessages(newVal)
    newMessages.value = newVal?.newMessages
  }
)

watch(
  () => cookieRepository.isLoggedInCandidate,
  (newVal) => {
    isLoggedInCandidate.value = newVal
  }
)

return { __sfc: true,emit, toggleMenu, app, localization, appStore, stats, hasNewMessages, newMessages, messagesIcon, applicationsLink, profileLink, accountLink, resumeLink, sidebarCandidateTitle, myJobs, myProfile, myAccount, resume, briefcaseIcon, circleUserIcon, fileIcon, slidersIcon, cookieRepository, isLoggedInCandidate, route, exactActiveClass, links, CIcon }
}

})